.outro {
  min-height: calc(100vh - var(--navbar-height));
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-primary);
  padding: var(--space-xl);
}

.container {
  text-align: center;
  max-width: 700px;
}

.statusSection {
  display: inline-flex;
  align-items: center;
  gap: var(--space-sm);
  background: rgba(57, 255, 20, 0.1);
  border: 1px solid rgba(57, 255, 20, 0.3);
  border-radius: 999px;
  padding: var(--space-xs) var(--space-md);
  margin-bottom: var(--space-xl);
}

.statusDot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--accent-green);
  box-shadow: 0 0 10px var(--glow-green);
  animation: pulse 2s ease-in-out infinite;
}

.statusText {
  font-family: var(--font-heading);
  font-size: var(--text-xs);
  letter-spacing: 2px;
  color: var(--accent-green);
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.ascii {
  font-family: 'Consolas', 'Courier New', monospace;
  font-size: clamp(0.35rem, 1.2vw, 0.65rem);
  color: var(--accent-cyan);
  text-shadow: 0 0 10px var(--glow-cyan);
  margin-bottom: var(--space-2xl);
  line-height: 1;
  letter-spacing: 0;
}

.info {
  display: flex;
  justify-content: center;
  gap: var(--space-2xl);
  margin-bottom: var(--space-2xl);
  padding: var(--space-lg);
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
}

.infoItem {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
}

.infoLabel {
  font-family: var(--font-heading);
  font-size: 10px;
  letter-spacing: 2px;
  color: var(--text-muted);
}

.infoValue {
  font-family: var(--font-code);
  font-size: var(--text-sm);
  color: var(--accent-cyan);
}

.contact {
  margin-bottom: var(--space-2xl);
}

.contactTitle {
  font-family: var(--font-heading);
  font-size: var(--text-sm);
  letter-spacing: 3px;
  color: var(--text-muted);
  margin-bottom: var(--space-md);
}

.contactLinks {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
  align-items: center;
}

.contactLink {
  display: inline-flex;
  align-items: center;
  gap: var(--space-sm);
  color: var(--accent-cyan);
  text-decoration: none;
  font-family: var(--font-code);
  font-size: var(--text-sm);
  padding: var(--space-sm) var(--space-md);
  border: 1px solid var(--border-accent);
  border-radius: var(--radius-sm);
  transition: all var(--transition-fast);
}

.contactLink:hover {
  background: var(--glow-cyan);
  box-shadow: 0 0 15px var(--glow-cyan);
}

.linkIcon {
  font-size: var(--text-base);
}

.footer {
  padding-top: var(--space-xl);
  border-top: 1px solid var(--border);
}

.footer p {
  font-size: var(--text-sm);
  color: var(--text-muted);
  margin-bottom: var(--space-xs);
}

.copyright {
  font-size: var(--text-xs) !important;
  color: var(--text-muted);
}

.icp {
  font-size: var(--text-xs) !important;
  color: var(--text-muted);
  margin-top: var(--space-sm);
}

.icp a {
  color: inherit;
  text-decoration: none;
}

.icp a:hover {
  color: var(--accent-cyan);
}

@media (max-width: 640px) {
  .info {
    flex-direction: column;
    gap: var(--space-md);
  }
}
